import {
  Checkbox, Icon, TextField, Tooltip, Typography,
} from '@gupshup-frontend/gupshup-ts-components';
import { isLto, BUTTON_TYPE, createButton } from '../state';
import { friendlyError } from './errorMessages';

// LimitedTimeOfferDto.text max length — TEMPLATE_LIMITS.ltoTextMaxChars in gs-intg-services'
// src/modules/WhatsApp/enterprise-template/constants/template-media-rules.constant.ts
// (confirmed value 16).
const LTO_TEXT_MAX_CHARS = 16;

// Limited time offer — offer title plus an optional expiry countdown. Only rendered for the LTO
// subcategory (isLto), where Form/validate.js makes the offer title mandatory unconditionally —
// hence no "Optional" pill here, unlike most other cards.
const LtoSection = ({ state, dispatch, errors, disabled }) => {
  if (!isLto(state)) {
    return null;
  }

  const { value } = state.lto.offerTitle;
  const submitError = errors['lto.offerTitle.value'];

  const handleTextChange = (event) => {
    dispatch({
      type: 'merge',
      path: 'lto.offerTitle',
      value: { value: event.target.value, error: '' },
    });
  };

  const handleExpiryChange = (event) => {
    const { checked } = event.target;
    dispatch({ type: 'set', path: 'lto.isExpiryChecked', value: checked });
    // Enterprise requires copy_code as the FIRST CTA whenever the offer has expiry
    // (MessageTemplate.java:1811-1850, "Please pass buttons in required sequence") — insert/remove
    // it at index 0 here, locked so Buttons.js won't offer to retype/remove/drag it (T6), same as
    // the URL button Category.js seeds on entering LTO.
    if (checked) {
      dispatch({
        type: 'set',
        path: 'buttons',
        value: [createButton(BUTTON_TYPE.COPY_CODE, { locked: true }), ...state.buttons],
      });
    } else {
      dispatch({
        type: 'set',
        path: 'buttons',
        value: state.buttons.filter((btn) => !(btn.type === BUTTON_TYPE.COPY_CODE && btn.locked)),
      });
    }
  };

  return (
    <div className="br-tpl-form-card" data-testid="bloomreach-templates-form-lto">
      <div className="br-tpl-form-card-heading-row">
        <div className="br-tpl-form-card-heading">
          <Typography variant="subtitle1" data-testid="bloomreach-templates-form-lto-heading">
            Limited time offer*
          </Typography>
        </div>
      </div>
      <TextField
        fullWidth
        label="Offer Title"
        value={value}
        onChange={handleTextChange}
        disabled={disabled}
        placeholder="Offer Title"
        error={Boolean(submitError)}
        helperText={friendlyError(submitError)}
        autoComplete="off"
        inputProps={{
          maxLength: LTO_TEXT_MAX_CHARS,
          'data-testid': 'bloomreach-templates-form-lto-textfield',
        }}
      />
      <Typography variant="caption" className="br-tpl-form-char-count" data-testid="bloomreach-templates-form-lto-count">
        {`Characters: ${value.length} / ${LTO_TEXT_MAX_CHARS}`}
      </Typography>
      <div className="br-tpl-form-inline-row">
        <Checkbox
          checked={state.lto.isExpiryChecked}
          onChange={handleExpiryChange}
          disabled={disabled}
          label="Add expiry period to this offer"
          data-testid="bloomreach-templates-form-lto-expiry-checkbox"
        />
        <Tooltip
          placement="right"
          title="The preview will display the default expiration date."
          data-testid="bloomreach-templates-form-lto-expiry-tooltip"
        >
          <span>
            <Icon name="question" size={18} showCursor />
          </span>
        </Tooltip>
      </div>
      {errors['lto.buttons'] && (
        <Typography variant="caption" color="error" data-testid="bloomreach-templates-form-lto-buttons-error">
          {friendlyError(errors['lto.buttons'])}
        </Typography>
      )}
    </div>
  );
};

export default LtoSection;
